var exports = {
  "k": "x61f99309--acc1af--container",
  "Q": "x61f99309--acc1af--text",
};

module.exports = exports;
